import { useSearchParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

function getResultMessage(ratio) {
  if (ratio >= 0.8) return { text: "Puiku!", emoji: "🏆" };
  if (ratio >= 0.6) return { text: "Gerai!", emoji: "🌟" };
  if (ratio >= 0.4) return { text: "Neblogai!", emoji: "👍" };
  return { text: "Bandyk dar!", emoji: "💪" };
}

export default function QuizStudentResults() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const studentName = searchParams.get("name") || "—";
  const total = Math.max(parseInt(searchParams.get("total") || "0", 10), 0);
  const rawScore = parseInt(searchParams.get("score") || "0", 10);
  const score = total ? Math.min(Math.max(rawScore, 0), total) : Math.max(rawScore, 0);

  const ratio = total ? score / total : 0;
  const resultMessage = getResultMessage(ratio);
  const correct = score;
  const wrong = total ? total - score : 0;

  return (
    <div className="flex-1 w-full p-5 flex flex-col items-center justify-center">
      <div className="w-full max-w-md mx-auto">
        {/* Score Card */}
        <div className="bg-white rounded-[32px] p-8 text-center mb-6 shadow-sm border border-blue-100 relative overflow-hidden">
          <div className="absolute -top-10 -right-10 w-32 h-32 bg-yellow-100 rounded-full opacity-50 mix-blend-multiply"></div>
          <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-blue-100 rounded-full opacity-50 mix-blend-multiply"></div>

          <div className="relative z-10">
            <div className="text-6xl mb-4 animate-bounce">{resultMessage.emoji}</div>
            <h1 className="text-2xl font-bold text-gray-800 mb-1">{resultMessage.text}</h1>
            <p className="text-gray-500 mb-1">{studentName}</p>
            <p className="text-gray-400 text-sm mb-6">{t("quiz.quizComplete")}</p>

            <div className="inline-block bg-blue-50 rounded-3xl px-8 py-4 mb-8 border border-blue-100">
              <p className="text-5xl font-black text-darkblue">
                {score}
                {total ? <span className="text-2xl text-blue-300">/{total}</span> : null}
              </p>
            </div>

            {total > 0 && (
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-green-50 rounded-2xl p-4 border border-green-100">
                  <p className="text-2xl font-bold text-green-600 mb-1">{correct}</p>
                  <p className="text-sm font-medium text-green-800">{t("quiz.correctAnswers")}</p>
                </div>
                <div className="bg-red-50 rounded-2xl p-4 border border-red-100">
                  <p className="text-2xl font-bold text-red-600 mb-1">{wrong}</p>
                  <p className="text-sm font-medium text-red-800">{t("quiz.wrongAnswers")}</p>
                </div>
              </div>
            )}
          </div>
        </div>

        <p className="text-center text-sm text-gray-400 mb-6">
          {t("quiz.seeTeacherLeaderboard") || "Your teacher can see the full leaderboard."}
        </p>

        <button
          onClick={() => navigate("/quiz")}
          className="secondary-btn w-full !rounded-full h-12 !py-0 flex items-center justify-center text-base font-semibold"
        >
          {t("quiz.backToHome")}
        </button>
      </div>
    </div>
  );
}
